import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dueDateText']
  static values = {
    id: String,
    sourceId: String,
    dueDate: String
  }

  connect() {
    if (this.sourceIdValue) {
      this.fetchPaymentMethod()
    }
  }

  fetchPaymentMethod() {
    const locale = document.documentElement.lang || 'en'

    fetch(`/${locale}/oa/payment_methods/${this.sourceIdValue}.json`, {
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(response => response.json())
      .then(data => {
        this.updateDueDateText(data.last4)
      })
      .catch(error => {
        console.error('Error fetching payment method:', error)
        this.updateDueDateText(null)
      })
  }

  updateDueDateText(last4) {
    const dueDate = new Date(this.dueDateValue)
    const dueDateFormatted = this.formatDate(dueDate)

    // Get translations from data attributes or use defaults
    const dueWithCardText = this.element.dataset.dueWithCardText || `Due ${dueDateFormatted} (ending in ${last4})`
    const dueText = this.element.dataset.dueText || `Due ${dueDateFormatted}`

    let text
    if (last4) {
      text = dueWithCardText
        .replace('__DATE__', dueDateFormatted)
        .replace('%{date}', dueDateFormatted)
        .replace('__LAST4__', last4)
        .replace('%{last4}', last4)
    } else {
      text = dueText
        .replace('__DATE__', dueDateFormatted)
        .replace('%{date}', dueDateFormatted)
        .replace('%<date>s', dueDateFormatted)
    }

    if (this.hasDueDateTextTarget) {
      this.dueDateTextTarget.textContent = text
    }
  }

  formatDate(date) {
    const locale = document.documentElement.lang || 'en'
    return date.toLocaleDateString(locale, {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
      timeZone: 'UTC'
    })
  }

  payNow(event) {
    event.preventDefault()
    const customEvent = new CustomEvent('chargeable-payment-term:pay-now', {
      bubbles: true,
      detail: { paymentTermId: this.idValue }
    })
    this.element.dispatchEvent(customEvent)
  }
}
